import React from 'react';
import ReactCurrencyInput from 'react-currency-input';

const CurrencyInput = (props, ref) => (
    <ReactCurrencyInput {...props} ref={ref} />
);

export default React.forwardRef(CurrencyInput);
